import {
    GET_PURCHASE_INVOICE_LIST_PROGRESS, GET_PURCHASE_INVOICE_LIST_SUCCESS, GET_PURCHASE_INVOICE_LIST_FAILURE,
    ADD_PURCHASE_INVOICE_PROGRESS, ADD_PURCHASE_INVOICE_SUCCESS, ADD_PURCHASE_INVOICE_FAILURE,
    EDIT_DELETE_PURCHASE_INVOICE_PROGRESS, EDIT_DELETE_PURCHASE_INVOICE_SUCCESS, EDIT_DELETE_PURCHASE_INVOICE_FAILURE,
   
    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    purchaseInvoice: [],
    loginUser: null,
    lastEntryNo:null,
    error: false,
    loading: false,
    message: null
}

const purchase_invoice_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PURCHASE_INVOICE_LIST_SUCCESS:
            return { ...state, purchaseInvoice: action.purchaseInvoice, lastEntryNo: action.purchaseInvoice[0].inwardNo, loading: false };
        case GET_PURCHASE_INVOICE_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PURCHASE_INVOICE_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_PURCHASE_INVOICE_PROGRESS:
            return { ...state, loading: true };
        case ADD_PURCHASE_INVOICE_SUCCESS:
            return { ...state, purchaseInvoice: [...state.purchaseInvoice, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_PURCHASE_INVOICE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_PURCHASE_INVOICE_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_PURCHASE_INVOICE_SUCCESS:
            return {
                ...state,
                purchaseInvoice: state.purchaseInvoice.map((purchaseInvoice) =>
                purchaseInvoice.id === action.payload.id ? action.payload : purchaseInvoice
                ),
               message: action.payload.message 
            };
        case EDIT_DELETE_PURCHASE_INVOICE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default purchase_invoice_reducer;